<div id="main-wrapper">
  <div id="content">
    <div class="container-fluid invoice-container" style="max-width: 1048px">

      <body>


        <table width="1000" border="0" cellspacing="0" cellpadding="0"
          style="border:1px solid #c2c2c2;font-family: 'Roboto', sans-serif;">

          <tr style="line-height:-1px">
            <td style="border-bottom: 1px solid #c2c2c2">
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr style="line-height:-1px">
                    <td align="left" style="padding:10px 20px"><img class="" src="{{Cruisedata.logo}}" /></td>
                    <td align="left" style="padding:10px 20px"></td>
                    <td align="right" style="padding:10px 20px"><img class="" src="{{paxdata.logourl}}" /></td>
                  </tr>
                </tbody>
              </table>

            </td>
          </tr>

          <tr style="line-height:-1px">
            <td valign="top">
              <table width="100%" border="0" cellspacing="0" cellpadding="0"
                style="padding:0 15px;font-family: 'Roboto', sans-serif; ">



                <tr style="line-height:-1px; text-align: right">
                  <td valign="top"
                    style="font-family: 'Roboto', sans-serif; font-size:16px; color:#000; font-weight:normal;width:100%; padding: 15px 0; line-height: 22px">
                    <span
                      style="font-family: 'Roboto', sans-serif; font-size:17px; color:#000; font-weight:bold;width:100%;">Travel
                      {{paxdata.CompanyName}}</span><br>
                    {{paxdata.GSTRegisteredAddress}}<br>
                    <!-- {{paxdata.City}} – {{paxdata.PinCode}}<br> -->
                    {{paxdata.PhoneNumber}}<br>

                  </td>
                </tr>

                <tr style="line-height:-1px">
                  <td valign="top">

                    <table width="100%" border="0" cellspacing="0" cellpadding="0"
                      style="background:#f4f6f8;padding:15px; border-bottom:1px solid #c2c2c2;font-family: 'Roboto', sans-serif;">
                      <tr style="line-height:-1px">
                        <td
                          style="font-family: 'Roboto', sans-serif; font-size:19px; color:#000; font-weight:bold;width:100%; line-height: 23px"
                          align="left">
                          {{Cruisedata.startDate}}-{{Cruisedata.endDate}}<br />
                          <span
                            style="font-family: 'Roboto', sans-serif; font-size:14px; color:#525252;font-weight:normal;">
                            {{Cruisedata.Nights}} Repositioning: {{Cruisedata.FriendlyCruiseName}},
                            {{Cruisedata.Continent}}</span>
                        </td>

                        <td style="font-family: 'Roboto', sans-serif; font-size:16px; color:#525252; font-weight:bold;"
                          align="right">Ref. No.<br /><span
                            style="font-family: 'Roboto', sans-serif; font-size:25px; color:#000; font-weight:bold;width:100%;">{{transactionId}}</span>
                        </td>
                      </tr>
                    </table>

                  </td>
                </tr>

                <tr style="line-height:-1px">
                  <td valign="top" style="padding:15px 0;border-bottom:1px solid #c2c2c2">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0"
                      style="font-family: 'Roboto', sans-serif;">
                      <tr style="line-height:-1px">
                        <td style="padding-right: 25px; width: 30%">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0"
                            style="text-align: right;line-height: 25px;">
                            <tbody>
                              <tr style="line-height:-1px">
                                <td
                                  style="font-size: 26px; font-weight: bold; color: #000000;font-family:Arial, Helvetica, sans-serif;">
                                  {{Cruisedata.DepartTime}}</td>
                              </tr>
                              <tr style="line-height:-1px">
                                <td
                                  style="font-size: 15px; font-weight: normal; color: #000000;font-family:Arial, Helvetica, sans-serif;">
                                  <span style="font-size: 18px; font-weight: bold">{{Cruisedata.startDate}}</span>
                                </td>
                              </tr>
                              <tr style="line-height:-1px">
                                <td
                                  style="font-size: 13px; font-weight: normal; color: #525252;font-family:Arial, Helvetica, sans-serif;">
                                  {{Cruisedata.EmbarkFrom}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style="padding-right: 25px; width: 15%">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0" style="text-align: center">
                            <tbody>
                              <tr style="line-height:-1px">
                                <td style="border-bottom: 1px dashed #000; padding: 10px"> <img
                                    src="{{Cruisedata.logo}}" width="37" height="33" alt="" /></td>
                              </tr>
                              <tr style="line-height:-1px">
                                <td
                                  style="font-size: 15px; font-weight: normal; color: #000000;font-family:Arial, Helvetica, sans-serif; padding-top: 5px">
                                  {{Cruisedata.Nights}}</td>
                              </tr>
                            </tbody>
                          </table>

                        </td>
                        <td style="padding-left: 25px; width: 30%">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0"
                            style="text-align: left;line-height: 25px;">
                            <tbody>
                              <tr style="line-height:-1px">
                                <td
                                  style="font-size: 26px; font-weight: bold; color: #000000;font-family:Arial, Helvetica, sans-serif;">
                                  {{Cruisedata.ArriveTime}}</td>
                              </tr>
                              <tr style="line-height:-1px">
                                <td
                                  style="font-size: 15px; font-weight: normal; color: #000000;font-family:Arial, Helvetica, sans-serif;">
                                  <span style="font-size: 18px; font-weight: bold">{{Cruisedata.endDate}}</span>
                                </td>
                              </tr>
                              <tr style="line-height:-1px">
                                <td
                                  style="font-size: 13px; font-weight: normal; color: #525252;font-family:Arial, Helvetica, sans-serif;">
                                  {{Cruisedata.EmbarkTo}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style="width: 25%" align="right"><img class="jaleshimage"
                            src="{{Cruisedata.itineraryImage}}" alt="" style="border: 1px solid #ccc" /></td>
                      </tr>

                    </table>
                  </td>
                </tr>

                <tr style="line-height:-1px">
                  <td>
                    <table align="left" width="100%" border="0" cellspacing="0" cellpadding="0"
                      style="border-bottom: 1px solid #cecece">
                      <tbody>
                        <tr style="line-height:-1px">
                          <td>
                            <table width="100%" border="0" cellspacing="0" cellpadding="0" style="padding: 10px">
                              <tbody>
                                <tr style="line-height:-1px">
                                  <td
                                    style="font-size: 13px; font-weight: normal; color: #000;font-family:Arial, Helvetica, sans-serif;">
                                    Cabins & Category</td>
                                  <td
                                    style="font-size: 13px; font-weight: normal; color: #000;font-family:Arial, Helvetica, sans-serif; border-right: 1px solid #6b6b6b; padding-left: 10px">
                                    <span style="font-size: 17px; font-weight: bold">{{bookingList.PaxCount}}</span>
                                  </td>

                                  <td *ngFor="let cabin of Cruisedata.cabinPrice"
                                    style="font-size: 13px; font-weight: normal; color: #000;font-family:Arial, Helvetica, sans-serif; border-right: 1px solid #6b6b6b; padding-left: 10px">
                                    <span style="font-size: 17px; font-weight: bold">{{cabin.cabintype}}</span>
                                  </td>

                                  <!-- <td
                              style="font-size: 13px; font-weight: normal; color: #000;font-family:Arial, Helvetica, sans-serif;">
                              <span style="font-size: 17px; font-weight: bold; padding-left: 10px">02</span> Suite</td> -->
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td style="border-left: 1px solid #cecece">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                              <tbody>
                                <tr style="line-height:-1px">
                                  <td
                                    style="font-size: 13px; font-weight: normal; color: #000;font-family:Arial, Helvetica, sans-serif; padding-left: 10px">
                                    Deck no. <span
                                      style="font-size: 17px; font-weight: bold">{{bookingList.Deck}}</span></td>
                                  <td
                                    style="font-size: 13px; font-weight: normal; color: #000;font-family:Arial, Helvetica, sans-serif;">
                                    Cabin no. <span
                                      style="font-size: 17px; font-weight: bold">{{bookingList.Cabin}}</span></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>


              </table>
            </td>
          </tr>

          <tr style="line-height:-1px">
            <td
              style="font-size:18px; font-weight:bold; color:#000;font-family: 'Roboto', sans-serif; padding-top:10px; padding-left:15px;">
              Traveler(s) Information </td>
          </tr>
          <tr style="line-height:-1px">
            <td style="padding:15px">
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tr style="line-height:-1px">
                  <td
                    style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0 8px 10px; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd ">
                    Name</td>
                  <td
                    style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd ">
                    Deck</td>
                  <td
                    style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd ">
                    Cabin No.</td>
                </tr>

                <tr style="line-height:-1px" *ngFor="let Pax of bookingList.paxDetails">
                  <td
                    style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0 8px 10px; border-bottom:1px solid #d9dbdd ">
                    {{Pax.Title}}&nbsp;{{Pax.FirstName}}&nbsp;{{Pax.LastName}};{{Pax.PaxType}}</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
                    {{bookingList.Deck}}</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
                    {{bookingList.Cabin}}</td>
                </tr>
              </table>

            </td>
          </tr>


          <tr style="line-height:-1px">
            <td
              style="font-size:18px; font-weight:bold; color:#000;font-family: 'Roboto', sans-serif; padding-top:10px; padding-left:15px;">
              Cruise Itinerary</td>
          </tr>
          <tr style="line-height:-1px">
            <td style="padding:15px">
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tr style="line-height:-1px">
                  <td
                    style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0 8px 10px; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
                    Date</td>
                  <td
                    style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
                    Day</td>
                  <!-- <td
              style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
              Arrive</td> -->
                  <td
                    style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
                    Depart</td>
                  <td
                    style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
                    Port / Itinerary</td>
                </tr>

                <tr style="line-height:-1px" *ngFor="let itinerary of Cruisedata.itinerary">
                  <td
                    style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0 8px 10px; border-bottom:1px solid #d9dbdd ">
                    {{itinerary.SailingDate}}</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
                    {{itinerary.Sailday}}</td>
                  <!-- <td
              style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
              -</td> -->
                  <td
                    style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
                    {{itinerary.Timings}}</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
                    {{itinerary.BriefDesc}}</td>
                </tr>

              </table>

            </td>
          </tr>

          <tr style="line-height:-1px">
            <td style="padding:15px">


              <table width="100%" border="0" cellspacing="0" cellpadding="0" style="border:1px solid #d9dbdd">
                <tr style="line-height:-1px">
                  <td
                    style="background:#f4f6f8; font-size:15px; font-weight:500; color:#000; padding:10px;font-family: 'Roboto', sans-serif;">
                    Fare Summary</td>
                </tr>
                <tr style="line-height:-1px">
                  <td>
                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                      <tr style="line-height:-1px">
                        <td
                          style="font-size:13px; font-weight:500; color:#000; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif;">
                          Traveller Type</td>
                        <td
                          style="font-size:13px; font-weight:500; color:#000; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                          Base Fare</td>
                        <td
                          style="font-size:13px; font-weight:500; color:#000; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                          Taxes and Charges</td>
                        <td
                          style="font-size:13px; font-weight:500; color:#000; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                          Total</td>
                      </tr>
                      <tr style="line-height:-1px" *ngFor="let basePrice of bookingList.paxDetails; let i = index">
                        <td
                          style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif;">
                          {{basePrice.PaxType}}&nbsp;{{i+1}}</td>
                        <td
                          style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                          ₹ {{basePrice.baseAmt |number}}</td>
                        <td
                          style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                          ₹ {{basePrice.portCharges |number}}</td>
                        <td
                          style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                          ₹ {{(basePrice.baseAmt-0)+(basePrice.portCharges-0)|number}}</td>
                      </tr>
                      <!-- <tr style="line-height:-1px">
                  <td
                    style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif;">
                    Child (1 X ₹ 2350)</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                    ₹ 4700.00</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                    ₹ 1036.00</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                    ₹ 2868.00</td>
                </tr>
                <tr style="line-height:-1px">
                  <td
                    style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif;">
                    Infant (1 X ₹ 1,200)</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                    ₹ 4700.00</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                    ₹ 1036.00</td>
                  <td
                    style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                    ₹ 2868.00</td>
                </tr> -->
                    </table>

                  </td>
                </tr>
                <tr style="line-height:-1px">
                  <td align="right"
                    style="font-size:15px; font-weight:400; color:#525252; padding:10px 8px 3px 8px;font-family: 'Roboto', sans-serif;">
                    GST: <span style="color:#000; font-weight:500">₹{{bookingList.GST |number}}</span></td>
                </tr>
                <tr style="line-height:-1px">
                  <td align="right"
                    style="font-size:15px; font-weight:400; color:#525252; padding:3px 8px;font-family: 'Roboto', sans-serif;">
                    TCS: <span style="color:#000; font-weight:500">₹{{bookingList.TCS |number}}</span></td>
                </tr>
                <tr style="line-height:-1px">
                  <td align="right"
                    style="font-size:15px; font-weight:400; color:#525252; padding:3px 8px;font-family: 'Roboto', sans-serif;">
                    Discount/Comm: <span style="color:#000; font-weight:500">₹{{bookingList.Comm |number}}</span></td>
                </tr>
                <tr style="line-height:-1px">
                  <td align="right"
                    style="font-size:15px; font-weight:400; color:#525252; padding:3px 8px 10px 8px;font-family: 'Roboto', sans-serif;">
                    Promo code discount: <span style="color:#000; font-weight:500">₹{{bookingList.PromoDiscount |number}}</span>
                  </td>
                </tr>
                <tr style="line-height:-1px">
                  <td align="right"
                    style="font-size:22px; font-weight:600; color:#000;border-top:1px solid #d9dbdd; padding:8px 8px;font-family: 'Roboto', sans-serif;">
                    Total Net Fare : <span style="color:#000; font-size:25px; font-weight:600">₹
                      {{bookingList.TxnAmt |number}}</span></td>
                </tr>
              </table>



            </td>
          </tr>
          <tr style="line-height:-1px">
            <td
              style="font-size:16px; font-weight:600; color:#000;font-family: 'Roboto', sans-serif; padding:15px 15px 0px 15px;">
              Terms & Conditions</td>
          </tr>

          <tr style="line-height:-1px">
            <td valign="top" style=" padding:15px;">


              <table width="100%" border="0" cellspacing="0" cellpadding="0"
                style="font-family: 'Roboto', sans-serif; ">

                <tr style="line-height:-1px">
                  <td>

                    <p
                      style="font-weight:400; color:#000;font-family: 'Roboto', sans-serif; font-size:13px; margin:8px 0; line-height: 22px">
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                      the
                      industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>

                    <p
                      style="font-weight:400; color:#000;font-family: 'Roboto', sans-serif; font-size:13px; margin:8px 0; line-height: 22px">
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                      the
                      industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>

                    <p
                      style="font-weight:400; color:#000;font-family: 'Roboto', sans-serif; font-size:13px; margin:8px 0; line-height: 22px">
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                      the
                      industry's standard dummy text ever since the 1500s,
                      when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>

                  </td>
                </tr>
                <tr style="line-height:-1px">
                  <td
                    style="font-size:16px; font-weight:600; color:#000;font-family: 'Roboto', sans-serif; padding:15px 0 5px 0;">
                    ATO Customer support Information</td>
                </tr>
                <tr style="line-height:-1px">
                  <td>
                    <p
                      style="font-weight:400; color:#000;font-family: 'Roboto', sans-serif; font-size:13px; margin:8px 0">
                      Telephone support:{{paxdata.PhoneNumber}} </p>
                    <p
                      style="font-weight:400; color:#000;font-family: 'Roboto', sans-serif; font-size:13px; margin:8px 0">
                      Email support: ­ <a href="mailto:{{paxdata.EmailId}}">{{paxdata.EmailId}}</a>
                    </p>
                    <p
                      style="font-weight:400; color:#000;font-family: 'Roboto', sans-serif; font-size:13px; margin:8px 0">
                      Note : ­ The above data is indicative and may change without notification. Kindly contact the airline directly for the latest information.
                    </p>
                  </td>
                </tr>
                <tr style="line-height:-1px">
                  <td
                    style="padding:5px 0px; font-weight:600; color:#363636;font-family: 'Roboto', sans-serif; font-size:15px;">
                    Important note: The courts of Mumbai have jurisdiction to entertain any suits or legal proceedings
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </body>
    </div>
  </div>
</div>